import React, { useContext, useEffect } from "react";

/// React router dom
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
import "./AppShellTheme.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";

/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import FoodOrder from "./components/Dashboard/FoodOrder";
import FavoriteMenu from "./components/Dashboard/FavoriteMenu";
import Message from "./components/Dashboard/Message";
import OrderHistory from "./components/Dashboard/OrderHistory";
import Notification from "./components/Dashboard/Notification";
import Bill from "./components/Dashboard/Bill";
import HomeSetting from "./components/Setting/Setting";
import CheckoutPage from "./components/Dashboard/CheckoutPage";

//Restaurant
import Restaurant from './components/Dashboard/Restaurant/Restaurant';
import Withdrow from './components/Dashboard/Restaurant/Withdrow';
import Menu from './components/Dashboard/Restaurant/Menu';
import CustomerReviews from './components/Dashboard/Restaurant/CustomerReviews';

//Drivers
import DeliverMain from './components/Dashboard/Drivers/DeliverMain';
import DeliverOrder from './components/Dashboard/Drivers/DeliverOrder';
import Feedback from './components/Dashboard/Drivers/Feedback';

/////Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";
import Theme7 from "./components/Dashboard/Demo/Theme7";


/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
//import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";


// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import MenuConfig from "../constants/MenuConfig";
import CommissionRuleList from "./pages/sales/commission_rule/CommissionRuleList";
import CommissionRuleNew from "./pages/sales/commission_rule/CommissionRuleNew";
import CategoryList from "./pages/main/category/CategoryList";
import CategoryNew from "./pages/main/category/CategoryNew";
import ProductList from "./pages/main/product/ProductList";
import ProductNew from "./pages/main/product/ProductNew";
import ServiceList from "./pages/main/service/ServiceList";
import ServiceNew from "./pages/main/service/ServiceNew";
import CustomerList from "./pages/main/customer/CustomerList";
import CustomerNew from "./pages/main/customer/CustomerNew";
import OrderList from "./pages/sales/order/OrderList";
import OrderNew from "./pages/sales/order/OrderNew";
import ReasonList from "./pages/sales/reason/ReasonList";
import ReasonNew from "./pages/sales/reason/ReasonNew";
import PlanList from "./pages/subscription/plan/PlanList";
import PlanNew from "./pages/subscription/plan/PlanNew";
import ClubPartnerList from "./pages/subscription/club/ClubPartnerList";
import ClubPartnerNew from "./pages/subscription/club/ClubPartnerNew";

import VendorList from "./pages/main/vendor/VendorList";
import VendorNew from "./pages/main/vendor/VendorNew";
import EmployeeList from "./pages/main/employee/EmployeeList";
import EmployeeNew from "./pages/main/employee/EmployeeNew";
import CardFlagList from "./pages/main/card_flag/CardFlagList";
import CardFlagNew from "./pages/main/card_flag/CardFlagNew";
import BranchList from "./pages/main/branch/BranchList";
import BranchNew from "./pages/main/branch/BranchNew";
import BranchWorkingHours from "./pages/main/branch/BranchWorkingHours";

import ReportsHub from "./pages/reports/ReportsHub";
import HelpCenter from "./pages/help/HelpCenter";
import EmployeeStatementReport from "./pages/reports/EmployeeStatementReport";
import PotReport from "./pages/reports/PotReport";
import EmployeeFinancialSummaryReport from "./pages/reports/EmployeeFinancialSummaryReport";
import SalesReport from "./pages/reports/SalesReport";

import AppointmentDashboard from "./pages/appointment/AppointmentDashboard";
import AppointmentStandalone from "./pages/appointment/AppointmentStandalone";
import AppointmentReviewReport from "./pages/appointment/AppointmentReviewReport";
import AppointmentList from "./pages/appointment/AppointmentList";
import AppointmentBlockList from "./pages/appointment/AppointmentBlockList";
import BlockedCustomerList from "./pages/appointment/BlockedCustomerList";
import SpecialDayList from "./pages/appointment/special_day/SpecialDayList";
import SpecialDayNew from "./pages/appointment/special_day/SpecialDayNew";
import AppointmentNew from "./pages/appointment/AppointmentNew";
import ScoreNew from "./pages/gamification/score/ScoreNew";
import ScoreList from "./pages/gamification/score/ScoreList";
import PotDashboard from "./pages/gamification/pot/PotDashboard";
import PotBonusRuleList from "./pages/gamification/pot_bonus/PotBonusRuleList";
import PotBonusRuleNew from "./pages/gamification/pot_bonus/PotBonusRuleNew";
import PerformancePlanList from "./pages/performance/plan/PerformancePlanList";
import PerformancePlanNew from "./pages/performance/plan/PerformancePlanNew";
import PerformancePlanEmployeeList from "./pages/performance/employeePlan/PerformancePlanEmployeeList";
import PerformancePlanEmployeeNew from "./pages/performance/employeePlan/PerformancePlanEmployeeNew";
import PerformanceDashboard from "./pages/performance/dashboard/PerformanceDashboard";
import PerformanceReports from "./pages/performance/reports/PerformanceReports";
import { PERFORMANCE_REPORTS } from "./pages/performance/reports/performanceReportCatalog";
import EmployeePerformanceAnalysis from "./pages/performance/dashboard/analysis/EmployeePerformanceAnalysis";
import SubscriptionDashboard from "./pages/subscription/dashboard/SubscriptionDashboard";
import SubscriberList from "./pages/subscription/subscriber/SubscriberList";
import SubscriberNew from "./pages/subscription/subscriber/SubscriberNew";
import ChargeList from "./pages/subscription/charge/ChargeList";
import PaymentProviderManagement from "./pages/integration/payment_provider/PaymentProviderManagement";
import SaaSSignupPage from "./pages/public/signup/SaaSSignupPage";
import WhatsappBotNew from "./pages/integration/whatsapp/bot/WhatsappBotNew";
import WhatsappConversationList from "./pages/integration/whatsapp/conversation/WhatsappConversationList";
import WhatsappMessageLogList from "./pages/integration/whatsapp/message_log/WhatsappMessageLogList";
import ChatbotSettings from "./pages/integration/whatsapp/settings/ChatbotSettings";
import WhatsappDashboardPage from "./pages/integration/whatsapp/WhatsappDashboardPage";

import Birthdays from "./components/Dashboard/Main/Birtdays";
import NonReturningCustomers from "./components/Dashboard/Main/NonReturningCustomers";
import UserList from "./pages/identity/user/UserList";
import UserNew from "./pages/identity/user/UserNew";
import ProtectedRoute from "./route/ProtectedRoute";
import RestockList from "./pages/stock_control/restock/RestockList";
import RestockNew from "./pages/stock_control/restock/RestockNew";
import StockList from "./pages/stock_control/stock/StockList";
import StockhNew from "./pages/stock_control/stock/StockNew";
import CashList from "./pages/cash_flow/cash/CashList";
import CashNew from "./pages/cash_flow/cash/CashNew";
import TransactionCashFlowList from "./pages/cash_flow/transaction/TransactionCashFlowList";
import TransactionCashFlowNew from "./pages/cash_flow/transaction/TransactionCashFlowNew";
import PayableReceivableCashFlowList from "./pages/cash_flow/payable_receivable/PayableReceivableCashFlowList";
import PayableReceivableCashFlowNew from "./pages/cash_flow/payable_receivable/PayableReceivableCashFlowNew";
import CategoryCashFlowList from "./pages/cash_flow/category/CategoryList";
import CategoryCashFlowNew from "./pages/cash_flow/category/CategoryNew";
import AdvanceList from "./pages/cash_flow/advance/AdvanceList";
import AdvanceNew from "./pages/cash_flow/advance/AdvanceNew";
import EmployeeConsumptionList from "./pages/cash_flow/consumption/EmployeeConsumptionList";
import EmployeeConsumptionNew from "./pages/cash_flow/consumption/EmployeeConsumptionNew";
import EmployeePaymentList from "./pages/cash_flow/employee_payment/EmployeePaymentList";
import EmployeeBonusList from "./pages/cash_flow/bonus/EmployeeBonusList";
import EmployeeBonusNew from "./pages/cash_flow/bonus/EmployeeBonusNew";
import DreReport from "./pages/cash_flow/dre/DreReport";
import ImportData from "./pages/cash_flow/import/ImportData";
import GroupList from "./pages/identity/group/GroupList";
import GroupNew from "./pages/identity/group/GroupNew";

// SUPER ADMIN
import CompanyList from "./pages/superadmin/company/CompanyList";
import CompanyProvisionNew from "./pages/superadmin/company/CompanyProvisionNew";
import CompanyApiList from "./pages/superadmin/company_apis/CompanyApiList";
import CompanyApiNew from "./pages/superadmin/company_apis/CompanyApiNew";
import ParametersDashboard from "./pages/superadmin/parameters/ParametersDashboard";
import WhatsappConnectionList from "./pages/superadmin/whatsapp/WhatsappConnectionList";
import AnnouncementList from "./pages/superadmin/announcement/AnnouncementList";
import AnnouncementNew from "./pages/superadmin/announcement/AnnouncementNew";
import SaaSPlanList from "./pages/superadmin/saas_billing/SaaSPlanList";
import SaaSContractList from "./pages/superadmin/saas_billing/SaaSContractList";
import SaaSWebhookList from "./pages/superadmin/saas_billing/SaaSWebhookList";
import SaaSBlockedPage from "./pages/saas/SaaSBlockedPage";
import MyPlanPage from "./pages/saas/MyPlanPage";
import SaaSPlanForm from "./pages/superadmin/saas_billing/SaaSPlanForm";
import SaaSContractForm from "./pages/superadmin/saas_billing/SaaSContractForm";
import PlatformAnnouncementModal from "./components/Common/PlatformAnnouncementModal";
// import AiSupportWidget from "./components/AiSupport/AiSupportWidget";

const Markup = () => {

  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "dashboard-dark", component: <DashboardDark /> },
    { url: "food-order", component: <FoodOrder /> },
    { url: "favorite-menu", component: <FavoriteMenu /> },
    { url: "message", component: <Message /> },
    { url: "order-history", component: <OrderHistory /> },
    { url: "notification", component: <Notification /> },
    { url: "bill", component: <Bill /> },
    { url: "setting", component: <HomeSetting /> },
    { url: "setting/:tab", component: <HomeSetting /> },
    { url: "checkout", component: <CheckoutPage /> },

    // DASHBOARD
    { url: MenuConfig.dashboard.birthdays.route, component: <Birthdays /> },
    { url: MenuConfig.dashboard.customer.nonReturning.route, component: <NonReturningCustomers /> },

    // MAIN //
    // Category
    { url: MenuConfig.main.category.route, component: <CategoryList /> },
    { url: MenuConfig.main.category.route + "/new", component: <CategoryNew /> },
    { url: MenuConfig.main.category.route + "/new/:id", component: <CategoryNew /> },

    // Card Flag
    { url: MenuConfig.main.card_flag.route, component: <CardFlagList /> },
    { url: MenuConfig.main.card_flag.route + "/new", component: <CardFlagNew /> },
    { url: MenuConfig.main.card_flag.route + "/new/:id", component: <CardFlagNew /> },

    // Product
    { url: MenuConfig.main.product.route, component: <ProductList /> },
    { url: MenuConfig.main.product.route + "/new", component: <ProductNew /> },
    { url: MenuConfig.main.product.route + "/new/:id", component: <ProductNew /> },

    // Service — reutiliza o catálogo, mantendo navegação e regras próprias.
    { url: MenuConfig.main.service.route, component: <ServiceList /> },
    { url: MenuConfig.main.service.route + "/new", component: <ServiceNew /> },
    { url: MenuConfig.main.service.route + "/new/:id", component: <ServiceNew /> },

    // Customer
    { url: MenuConfig.main.customer.route, component: <CustomerList /> },
    { url: MenuConfig.main.customer.route + "/new", component: <CustomerNew /> },
    { url: MenuConfig.main.customer.route + "/new/:id", component: <CustomerNew /> },

    // Vendor
    { url: MenuConfig.main.vendor.route, component: <VendorList /> },
    { url: MenuConfig.main.vendor.route + "/new", component: <VendorNew /> },
    { url: MenuConfig.main.vendor.route + "/new/:id", component: <VendorNew /> },

    // Employee
    { url: MenuConfig.main.employee.route, component: <EmployeeList /> },
    { url: MenuConfig.main.employee.route + "/new", component: <EmployeeNew /> },
    { url: MenuConfig.main.employee.route + "/new/:id", component: <EmployeeNew /> },

    // Branch
    { url: MenuConfig.main.branch.route, component: <BranchList /> },
    { url: MenuConfig.main.branch.route + "/new", component: <BranchNew /> },
    { url: MenuConfig.main.branch.route + "/new/:id", component: <BranchNew /> },
    { url: MenuConfig.main.branch_working_hours.route + "/:id", component: <BranchWorkingHours /> },

    // HELP //
    // Tutoriais em vídeo. Sem ProtectedRoute: o conteúdo é treinamento do produto e vale
    // para qualquer usuário autenticado, inclusive quem só usa o balcão.
    // Plano contratado, na visão da própria empresa. Sem ProtectedRoute: qualquer usuário
    // autenticado do tenant pode ver em que plano a empresa está e se há fatura aberta.
    { url: MenuConfig.my_plan.current.route, component: <MyPlanPage /> },

    { url: MenuConfig.help.tutorials.route, component: <HelpCenter /> },

    // REPORTS //
    { url: MenuConfig.reports.hub.route, component: <ReportsHub /> },
    { url: MenuConfig.reports.employee_statement.route, component: <EmployeeStatementReport /> },
    { url: MenuConfig.reports.pot.route, component: <PotReport /> },
    { url: MenuConfig.reports.financial_summary.route, component: <EmployeeFinancialSummaryReport /> },
    { url: MenuConfig.reports.extra_services.route, component: <SalesReport /> },

    // APPOINTMENT //
    { url: MenuConfig.appointment.dashboard.route, component: <AppointmentDashboard /> },
    { url: MenuConfig.appointment.review.route, component: <AppointmentReviewReport /> },
    { url: MenuConfig.appointment.block.route, component: <AppointmentBlockList /> },
    { url: MenuConfig.appointment.blocked_customer.route, component: <BlockedCustomerList /> },
    { url: MenuConfig.appointment.special_day.route, component: <SpecialDayList /> },
    { url: MenuConfig.appointment.special_day.route + "/new", component: <SpecialDayNew /> },
    { url: MenuConfig.appointment.special_day.route + "/new/:id", component: <SpecialDayNew /> },
    { url: MenuConfig.appointment.appointment.route, component: <AppointmentList /> },
    { url: MenuConfig.appointment.appointment.route + "/new", component: <AppointmentNew /> },
    { url: MenuConfig.appointment.appointment.route + "/new/:id", component: <AppointmentNew /> },

    // Drivers
    { url: "deliver-main", component: <DeliverMain /> },
    { url: "deliver-order", component: <DeliverOrder /> },
    { url: "feedback", component: <Feedback /> },

    { url: "withdrow", component: <Withdrow /> },
    { url: "menu", component: <Menu /> },
    //{ url: "orders", component: <Orders /> },
    { url: "customer-reviews", component: <CustomerReviews /> },

    // STOCK CONTROL //
    // Restock
    { url: MenuConfig.stock_control.restock.route, component: <RestockList /> },
    { url: MenuConfig.stock_control.restock.route + "/new", component: <RestockNew /> },

    // CASH FLOW //
    // Cash
    { url: MenuConfig.cash_flow.cash_registers.route, component: <CashList /> },
    { url: MenuConfig.cash_flow.cash_registers.route + "/new", component: <CashNew /> },

    // Transactions
    { url: MenuConfig.cash_flow.transaction.route, component: <TransactionCashFlowList /> },
    { url: MenuConfig.cash_flow.transaction.route + "/new", component: <TransactionCashFlowNew /> },

    // Payable Receivable
    { url: MenuConfig.cash_flow.payable_receivable.route, component: <PayableReceivableCashFlowList /> },
    { url: MenuConfig.cash_flow.payable_receivable.route + "/new", component: <PayableReceivableCashFlowNew /> },
    { url: MenuConfig.cash_flow.payable_receivable.route + "/new/:id", component: <PayableReceivableCashFlowNew /> },

    // Categories
    { url: MenuConfig.cash_flow.categories.route, component: <CategoryCashFlowList /> },
    { url: MenuConfig.cash_flow.categories.route + "/new", component: <CategoryCashFlowNew /> },
    { url: MenuConfig.cash_flow.categories.route + "/new/:id", component: <CategoryCashFlowNew /> },

    // Advances (vales)
    { url: MenuConfig.cash_flow.advance.route, component: <AdvanceList /> },
    { url: MenuConfig.cash_flow.advance.route + "/new", component: <AdvanceNew /> },
    { url: MenuConfig.cash_flow.advance.route + "/new/:id", component: <AdvanceNew /> },

    // Consumo da equipe. Sem /new/:id: consumo não se edita, só se cancela na lista.
    { url: MenuConfig.cash_flow.employee_consumption.route, component: <EmployeeConsumptionList /> },
    { url: MenuConfig.cash_flow.employee_consumption.route + "/new", component: <EmployeeConsumptionNew /> },
    { url: MenuConfig.cash_flow.employee_payment.route, component: <EmployeePaymentList /> },
    // Bonificações
    { url: MenuConfig.cash_flow.employee_bonus.route, component: <EmployeeBonusList /> },
    { url: MenuConfig.cash_flow.employee_bonus.route + "/new", component: <EmployeeBonusNew /> },
    { url: MenuConfig.cash_flow.employee_bonus.route + "/new/:id", component: <EmployeeBonusNew /> },

    // DRE Report
    { url: MenuConfig.cash_flow.dre_report.route, component: <DreReport /> },

    // Import Data
    { url: MenuConfig.cash_flow.import_data.route, component: <ImportData /> },

    // STOCK //
    { url: MenuConfig.stock_control.stock.route, component: <StockList /> },
    { url: MenuConfig.stock_control.stock.route + "/new/:id", component: <StockhNew /> },

    // SALES //
    // Order
    { url: MenuConfig.sales.order.route, component: <OrderList /> },
    { url: MenuConfig.sales.order.route + "/new", component: <OrderNew /> },
    // INFO(Devs): Rota utilizada para gerar uma venda diretamente de um agendamento.
    { url: MenuConfig.sales.order.route + "/appointment/:appointmentUuid", component: <OrderNew /> },
    // Mantém compatibilidade com links antigos que incluíam "new" no caminho.
    { url: MenuConfig.sales.order.route + "/new/appointment/:appointmentUuid", component: <OrderNew /> },

    // Reason
    { url: MenuConfig.sales.commission_rule.route, component: <CommissionRuleList /> },
    { url: MenuConfig.sales.commission_rule.route + "/new", component: <CommissionRuleNew /> },
    { url: MenuConfig.sales.commission_rule.route + "/new/:id", component: <CommissionRuleNew /> },
    { url: MenuConfig.sales.reason.route, component: <ReasonList /> },
    { url: MenuConfig.sales.reason.route + "/new", component: <ReasonNew /> },
    { url: MenuConfig.sales.reason.route + "/new/:id", component: <ReasonNew /> },

    // GAMIFICATION //
    // PERFORMANCE //
    { url: MenuConfig.performance.plan.route, component: <PerformancePlanList /> },
    { url: MenuConfig.performance.plan.route + "/new", component: <PerformancePlanNew /> },
    { url: MenuConfig.performance.plan.route + "/new/:id", component: <PerformancePlanNew /> },
    { url: MenuConfig.performance.employee_plan.route, component: <PerformancePlanEmployeeList /> },
    { url: MenuConfig.performance.employee_plan.route + "/new", component: <PerformancePlanEmployeeNew /> },
    { url: MenuConfig.performance.employee_plan.route + "/new/:id", component: <PerformancePlanEmployeeNew /> },
    { url: MenuConfig.performance.dashboard.route, component: <PerformanceDashboard /> },
    { url: MenuConfig.performance.reports.route, component: <PerformanceReports /> },
    ...PERFORMANCE_REPORTS.map(({ id, route, Component }) => ({
        url: route,
        component: <Component key={id} />
    })),
    // Análise individual aberta pelo cartão do colaborador no painel (mês e filial pela URL).
    { url: MenuConfig.performance.dashboard.route + "/employee/:employeeId", component: <EmployeePerformanceAnalysis /> },

    // GAMIFICATION //
    // Score
    { url: MenuConfig.gamification.score.route, component: <ScoreList /> },
    { url: MenuConfig.gamification.score.route + "/new", component: <ScoreNew /> },
    { url: MenuConfig.gamification.score.route + "/new/:id", component: <ScoreNew /> },

    // Pot
    { url: MenuConfig.gamification.pot.route, component: <PotDashboard /> },

    // Adicional do pote: acordo individual pago pela parte da empresa.
    { url: MenuConfig.gamification.pot_bonus_rule.route, component: <PotBonusRuleList /> },
    { url: MenuConfig.gamification.pot_bonus_rule.route + "/new", component: <PotBonusRuleNew /> },
    { url: MenuConfig.gamification.pot_bonus_rule.route + "/new/:id", component: <PotBonusRuleNew /> },

    // SUBSCRIPTION
    // Dashboard
    { url: MenuConfig.subscription.dashboard.route, component: <SubscriptionDashboard /> },
    
    // Plan
    { url: MenuConfig.subscription.plan.route, component: <PlanList /> },
    { url: MenuConfig.subscription.plan.route + "/new", component: <PlanNew /> },
    { url: MenuConfig.subscription.plan.route + "/new/:id", component: <PlanNew /> },

    // Subscriber
    { url: MenuConfig.subscription.subscription.route, component: <SubscriberList /> },
    { url: MenuConfig.subscription.subscription.route + "/new", component: <SubscriberNew /> },
    { url: MenuConfig.subscription.subscription.route + "/new/:id", component: <SubscriberNew /> },

    // Charge
    { url: MenuConfig.subscription.charge.route, component: <ChargeList /> },

    // Clube de parceiros
    { url: MenuConfig.subscription.club_partner.route, component: <ClubPartnerList /> },
    { url: MenuConfig.subscription.club_partner.route + "/new", component: <ClubPartnerNew /> },
    { url: MenuConfig.subscription.club_partner.route + "/new/:id", component: <ClubPartnerNew /> },

    // Reports

    // INTEGRATION
    // Payment Provider Management — super admin only: troca de provider e sync são ações críticas/irreversíveis
    { url: MenuConfig.integration.payment_provider.route, component: <PaymentProviderManagement />, superAdminOnly: true },
    { url: MenuConfig.chat_bot.dashboard.route, component: <WhatsappDashboardPage /> },
    { url: MenuConfig.chat_bot.bot.route, component: <WhatsappBotNew /> },
    { url: MenuConfig.chat_bot.bot.route + "/new", component: <WhatsappBotNew /> },
    { url: MenuConfig.chat_bot.bot.route + "/new/:id", component: <WhatsappBotNew /> },
    { url: MenuConfig.chat_bot.conversation.route, component: <WhatsappConversationList /> },
    { url: MenuConfig.chat_bot.settings.route, component: <ChatbotSettings /> },
    { url: MenuConfig.chat_bot.settings.route + "/:step", component: <ChatbotSettings /> },
    { url: "/integration/whatsapp/message-logs", component: <WhatsappMessageLogList /> },
    // Galax Pay
    // IDENTITY
    // User
    { url: MenuConfig.identity.user.route, component: <UserList />, adminOnly: true },
    { url: MenuConfig.identity.user.route + "/new", component: <UserNew />, adminOnly: true },
    { url: MenuConfig.identity.user.route + "/new/:id", component: <UserNew />, adminOnly: true },
    // Group
    { url: MenuConfig.identity.group.route, component: <GroupList />, adminOnly: true },
    { url: MenuConfig.identity.group.route + "/new", component: <GroupNew />, adminOnly: true },
    { url: MenuConfig.identity.group.route + "/new/:id", component: <GroupNew />, adminOnly: true },

    // SUPER ADMIN
    { url: "superadmin/company", component: <CompanyList />, superAdminOnly: true },
    { url: "superadmin/company/new", component: <CompanyProvisionNew />, superAdminOnly: true },
    { url: "superadmin/company/new/:id", component: <CompanyProvisionNew />, superAdminOnly: true },
    { url: "superadmin/company-apis", component: <CompanyApiList />, superAdminOnly: true },
    { url: "superadmin/company-apis/new", component: <CompanyApiNew />, superAdminOnly: true },
    { url: "superadmin/parameters", component: <ParametersDashboard />, superAdminOnly: true },
    { url: "superadmin/whatsapp", component: <WhatsappConnectionList />, superAdminOnly: true },
    { url: "superadmin/announcements", component: <AnnouncementList />, superAdminOnly: true },
    { url: "superadmin/announcements/new", component: <AnnouncementNew />, superAdminOnly: true },
    { url: "superadmin/announcements/new/:id", component: <AnnouncementNew />, superAdminOnly: true },
    { url: "superadmin/saas-billing", component: <Navigate to="/superadmin/saas-billing/plans" replace />, superAdminOnly: true },
    { url: "superadmin/saas-billing/plans", component: <SaaSPlanList />, superAdminOnly: true },
    { url: "superadmin/saas-billing/plans/new", component: <SaaSPlanForm />, superAdminOnly: true },
    { url: "superadmin/saas-billing/plans/new/:id", component: <SaaSPlanForm />, superAdminOnly: true },
    { url: "superadmin/saas-billing/contracts", component: <SaaSContractList />, superAdminOnly: true },
    { url: "superadmin/saas-billing/contracts/new", component: <SaaSContractForm />, superAdminOnly: true },
    { url: "superadmin/saas-billing/contracts/new/:id", component: <SaaSContractForm />, superAdminOnly: true },
    { url: "superadmin/saas-billing/webhooks", component: <SaaSWebhookList />, superAdminOnly: true },
    { url: "saas-blocked", component: <SaaSBlockedPage /> },

    /////Demo
    { url: "container-wide", component: <Theme1 /> },
    { url: "horizontal-sidebar", component: <Theme2 /> },
    { url: "nav-header", component: <Theme3 /> },
    { url: "secondary-sidebar", component: <Theme4 /> },
    { url: "mini-sidebar", component: <Theme5 /> },
    { url: "sidebar-theme", component: <Theme6 /> },
    { url: "header-theme", component: <Theme7 /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "post-details", component: <PostDetails /> },

    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    //{ url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },

    //
    ///// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },
    //
    ///// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    ///// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    ///// Widget
    { url: "widget-basic", component: <Widget /> },

    ///// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },
    //
    ///// table
    { url: 'table-filtering', component: <FilteringTable /> },
    { url: 'table-sorting', component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },

  ];

  return (
    <>
      <Routes>
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        <Route path='access-denied' element={<Error403 />} />
        {/* Contratação pelo site também abre logado, fora do layout do painel: quem já usa o
            sistema neste navegador (ou o superadmin conferindo a tela) vê a mesma página. */}
        <Route path='signup' element={<SaaSSignupPage />} />

        <Route element={<MainLayout agendaOnly />}>
          <Route path="appointment/agenda" element={<AppointmentStandalone />} />
        </Route>
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => {
            if (data.superAdminOnly) {
              return (
                <Route key={i} element={<ProtectedRoute superAdminOnly={true} />}>
                  <Route path={data.url} element={data.component} exact />
                </Route>
              );
            } else if (data.adminOnly) {
              return (
                <Route key={i} element={<ProtectedRoute />}>
                  <Route path={data.url} element={data.component} exact />
                </Route>
              );
            } else {
              return (
                <Route key={i} path={data.url} element={data.component} exact />
              );
            }
          })}
        </Route>

        {/** Rotas para telas expandidas */}
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout({ agendaOnly = false }) {
  const { menuToggle } = useContext(ThemeContext);

  useEffect(() => {
    // O tema de marca acompanha toda a área autenticada e é removido ao sair dela.
    document.body.classList.add('dashboard-brand-page');
    return () => document.body.classList.remove('dashboard-brand-page');
  }, []);

  return (
    <div id="main-wrapper" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
      {!agendaOnly && <Nav />}
      <div className={`content-body ${agendaOnly ? 'appointment-standalone-layout' : ''}`} style={agendaOnly ? undefined : { minHeight: window.screen.height - 45 }}>
        <div className={agendaOnly ? 'container-fluid' : 'container'}>
          <Outlet />
        </div>
      </div>
      {!agendaOnly && <Footer />}
      {!agendaOnly && <PlatformAnnouncementModal />}
      {/* Balão antigo da IA ocultado para não duplicar o atendimento do Chatwoot. */}
      {/* <AiSupportWidget /> */}
    </div>
  )
};

export default Markup;
